import React from 'react'
import axios from 'axios'

const getHoroscope = async ({ setLoading, setBackEvents, setResult, zodiac, color }) => {
    setLoading(true)
    setBackEvents(false)
    setResult('Espera un segundo! El genio esta frotando la lampara para ti')

    const cancelToken = axios.CancelToken.source()

    await axios.post('https://www.thewordartisan.online/api/v1/result/horoscope', {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "Content-Type",
            "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
            "Content-Type": "application/json",
        },
        horoscope: `\nQ: Dime mi horóscopo para la próxima semana si soy ${zodiac} y mi color favorito es ${color}.`
    },
    {
        cancelToken: cancelToken.token
    })

    .then((response) => {
        const data = response.data.result

        if (data === 'err' || data === 'again') {
            let tempZodiac = ''
            let tempColor = ''
    
            if (zodiac === 'Aries') { tempZodiac = presetAnswer.Aries }
            else if (zodiac === 'Tauro') { tempZodiac = presetAnswer.Tauro }
            else if (zodiac === 'Geminis') { tempZodiac = presetAnswer.Geminis }
            else if (zodiac === 'Cáncer') { tempZodiac = presetAnswer.Cáncer }
            else if (zodiac === 'Leo') { tempZodiac = presetAnswer.Leo }
            else if (zodiac === 'Virgo') { tempZodiac = presetAnswer.Virgo }
            else if (zodiac === 'Libra') { tempZodiac = presetAnswer.Libra }
            else if (zodiac === 'Escorpión') { tempZodiac = presetAnswer.Escorpión }
            else if (zodiac === 'Sagitario') { tempZodiac = presetAnswer.Sagitario }
            else if (zodiac === 'Capricornio') { tempZodiac = presetAnswer.Capricornio }
            else if (zodiac === 'Acuario') { tempZodiac = presetAnswer.Acuario }
            else if (zodiac === 'Piscis') { tempZodiac = presetAnswer.Piscis }
    
            if (color === 'Rojo') { tempColor = presetAnswer.Rojo }
            else if (color === 'Granate') { tempColor = presetAnswer.Granate }
            else if (color === 'Amarillo') { tempColor = presetAnswer.Amarillo }
            else if (color === 'Naranja') { tempColor = presetAnswer.Naranja }
            else if (color === 'Verde Claro') { tempColor = presetAnswer['Verde Claro'] }
            else if (color === 'Verde') { tempColor = presetAnswer.Verde }
            else if (color === 'Aguamarina') { tempColor = presetAnswer.Aguamarina }
            else if (color === 'Cielo Azul') { tempColor = presetAnswer['Cielo Azul'] }
            else if (color === 'Azul') { tempColor = presetAnswer.Azul }
            else if (color === 'Morado') { tempColor = presetAnswer.Morado }
            else if (color === 'Blanco') { tempColor = presetAnswer.Blanco }
            else if (color === 'Negro') { tempColor = presetAnswer.Negro }
    
            console.log("again")
            setResult(tempZodiac + ' ' + tempColor)
        } else {
            let final = data.data.replace("\n\n", "")
            setResult(final.replace("A: ", ""))
        }

        setLoading(false)
    })
    
    .catch((err) => {
        let tempZodiac = ''
        let tempColor = ''

        if (zodiac === 'Aries') { tempZodiac = presetAnswer.Aries }
        else if (zodiac === 'Tauro') { tempZodiac = presetAnswer.Tauro }
        else if (zodiac === 'Geminis') { tempZodiac = presetAnswer.Geminis }
        else if (zodiac === 'Cáncer') { tempZodiac = presetAnswer.Cáncer }
        else if (zodiac === 'Leo') { tempZodiac = presetAnswer.Leo }
        else if (zodiac === 'Virgo') { tempZodiac = presetAnswer.Virgo }
        else if (zodiac === 'Libra') { tempZodiac = presetAnswer.Libra }
        else if (zodiac === 'Escorpión') { tempZodiac = presetAnswer.Escorpión }
        else if (zodiac === 'Sagitario') { tempZodiac = presetAnswer.Sagitario }
        else if (zodiac === 'Capricornio') { tempZodiac = presetAnswer.Capricornio }
        else if (zodiac === 'Acuario') { tempZodiac = presetAnswer.Acuario }
        else if (zodiac === 'Piscis') { tempZodiac = presetAnswer.Piscis }

        if (color === 'Rojo') { tempColor = presetAnswer.Rojo }
        else if (color === 'Granate') { tempColor = presetAnswer.Granate }
        else if (color === 'Amarillo') { tempColor = presetAnswer.Amarillo }
        else if (color === 'Naranja') { tempColor = presetAnswer.Naranja }
        else if (color === 'Verde Claro') { tempColor = presetAnswer['Verde Claro'] }
        else if (color === 'Verde') { tempColor = presetAnswer.Verde }
        else if (color === 'Aguamarina') { tempColor = presetAnswer.Aguamarina }
        else if (color === 'Cielo Azul') { tempColor = presetAnswer['Cielo Azul'] }
        else if (color === 'Azul') { tempColor = presetAnswer.Azul }
        else if (color === 'Morado') { tempColor = presetAnswer.Morado }
        else if (color === 'Blanco') { tempColor = presetAnswer.Blanco }
        else if (color === 'Negro') { tempColor = presetAnswer.Negro }

        console.log("catch")
        setResult(tempZodiac + ' ' + tempColor)

        if (axios.isCancel(err)) {
            console.log("Axios post cancelled!")
        } else {
            console.log(err)
        }

        setLoading(false)
    })
}

export default getHoroscope

const presetAnswer = {
    Aries: 'Para la próxima semana, Aries, tu horóscopo dice que debes estar preparado para una semana de cambios y desafíos. Esto significa que tendrás que ser flexible y estar listo para adaptarte a los cambios.',
    Tauro: 'Para la próxima semana, los Tauro pueden esperar una semana de mucha energía y entusiasmo. Esto significa que tendrás la oportunidad de aprovechar al máximo tus habilidades y talentos. Esta semana también te traerá una nueva oportunidad para explorar nuevas ideas y proyectos.',
    Geminis: 'Para la próxima semana, Géminis, tu horóscopo dice que es el momento de tomar decisiones importantes. Estás en una etapa de tu vida en la que tienes que tomar decisiones que te llevarán a un nuevo camino.',
    Cáncer: 'Para la próxima semana, los Cáncer pueden esperar una semana de mucha energía y entusiasmo. Esto significa que tendrás la oportunidad de aprovechar al máximo tus habilidades y talentos. Esta semana también te traerá una nueva oportunidad para explorar nuevas ideas y proyectos.',
    Leo: 'Para la próxima semana, los astros te dicen que es el momento de tomar decisiones importantes. Estás en una etapa de cambio y debes estar preparado para aprovechar las oportunidades que se te presenten.',
    Virgo: 'Para la próxima semana, los astros te dicen que es el momento de tomar decisiones importantes. Estás en una etapa de cambio y debes estar preparado para aceptar los desafíos que se te presenten.',
    Libra: 'Para la próxima semana, Libra, tu horóscopo dice que es el momento de tomar decisiones importantes. Estás en una etapa de tu vida en la que tienes que tomar decisiones que te llevarán a un nuevo nivel.',
    Escorpión: 'Para la próxima semana, Escorpión, tu horóscopo dice que estarás en una etapa de cambios y de nuevas oportunidades. Estás listo para aprovechar al máximo cualquier oportunidad que se te presente.',
    Sagitario: 'Para la próxima semana, los astros te aconsejan que te tomes un tiempo para ti mismo.',
    Capricornio: 'Para la próxima semana, los nativos de Capricornio tendrán una semana llena de energía y optimismo.',
    Acuario: 'Para la próxima semana, Acuario, tu horóscopo dice que es el momento de tomar decisiones importantes.',
    Piscis: 'Para la próxima semana, Piscis, tu horóscopo dice que es el momento de tomar decisiones importantes. Estás en una etapa de tu vida en la que tienes que tomar decisiones que te llevarán a un nuevo camino.',
    
    Rojo: 'Tu color de la suerte para la próxima semana es el rojo, lo que significa que debes usar tu energía para abrirte a nuevas oportunidades y aprovechar al máximo cualquier oportunidad que se te presente.',
    Granate: 'El color Granate te ayudará a mantenerte centrado y aprovechar al máximo esta energía. Aprovecha esta semana para tomar decisiones importantes y avanzar hacia tus metas.',
    Amarillo: 'El color amarillo te ayudará a tomar decisiones con optimismo y energía. Aprovecha esta energía para tomar decisiones que te lleven a un futuro mejor.',
    Naranja: 'Esta semana, el color naranja te ayudará a encontrar la paz y la tranquilidad que necesitas. Aprovecha esta oportunidad para reflexionar sobre tu vida y tomar decisiones importantes. Esta semana también es un buen momento para conectar con tus amigos y familiares. Aprovecha esta oportunidad para compartir tus sentimientos y emociones con los demás.',
    'Verde Claro': 'Tu color de la suerte para la próxima semana es el verde claro, lo que significa que debes confiar en tu intuición y seguir adelante con tu plan. Esta semana también es un buen momento para conectar con tus amigos y familiares, así como para disfrutar de la compañía de los demás.',
    Verde: 'Tu color favorito, el verde, te ayudará a mantener la calma y la serenidad para tomar las mejores decisiones. Aprovecha esta oportunidad para explorar nuevas ideas y expandir tus horizontes.',
    Aguamarina: 'Tu color de la suerte para la próxima semana es el aguamarina, lo que significa que debes confiar en tu intuición y seguir tus instintos. Esta semana es una buena oportunidad para tomar decisiones importantes y para explorar nuevas ideas.',
    'Cielo Azul': 'Esta semana, el color cielo azul te ayudará a mantener la calma y la claridad mental para tomar las mejores decisiones.',
    Azul: 'Esta semana, el color azul te ayudará a conectar con tu intuición y a encontrar la paz interior. Aprovecha esta oportunidad para reflexionar sobre tu vida y tomar decisiones que te ayuden a avanzar. Esta semana también es un buen momento para conectar con tus amigos y familiares y compartir tus sentimientos.',
    Morado: 'Tu color favorito, el morado, te ayudará a conectar con tu intuición y a tomar decisiones sabias. Aprovecha esta energía para avanzar hacia tus metas y para disfrutar de la vida. No te olvides de tomar tiempo para ti mismo y para relajarte.',
    Blanco: 'Tu color favorito, el blanco, te ayudará a ver con claridad y a tomar decisiones sabias. Esta semana también es un buen momento para centrarte en tus metas y trabajar para alcanzarlas. Si te enfrentas a algunos desafíos, recuerda que tienes la fuerza y la determinación para superarlos.',
    Negro: 'Esta semana, tu color de la suerte es el negro, lo que significa que debes confiar en tu intuición y seguir tu corazón. Si te sientes abrumado por la cantidad de opciones que tienes, recuerda que el negro te ayudará a tomar la mejor decisión.',
}